/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VouchersType = exports.VoucherType = exports.VoucherStatus = exports.VoucherAllocatorType = exports.VoucherAllocationTypeBo = exports.PaymentCycle = exports.MarkAsUsedStatus = void 0;
var MarkAsUsedStatus;
(function (MarkAsUsedStatus) {
    MarkAsUsedStatus["UNKNOWN_MARK_AS_USED_STATUS"] = "UNKNOWN_MARK_AS_USED_STATUS";
    MarkAsUsedStatus["MARKED_SUCCESSFULLY"] = "MARKED_SUCCESSFULLY";
    MarkAsUsedStatus["PREVIOUSLY_MARKED"] = "PREVIOUSLY_MARKED";
    MarkAsUsedStatus["FAILED"] = "FAILED";
    MarkAsUsedStatus["NO_VOUCHERS_AVAILABLE"] = "NO_VOUCHERS_AVAILABLE";
})(MarkAsUsedStatus = exports.MarkAsUsedStatus || (exports.MarkAsUsedStatus = {}));
var PaymentCycle;
(function (PaymentCycle) {
    PaymentCycle["DAILY"] = "DAILY";
    PaymentCycle["WEEKLY"] = "WEEKLY";
    PaymentCycle["MONTHLY"] = "MONTHLY";
    PaymentCycle["QUARTERLY"] = "QUARTERLY";
    PaymentCycle["SEMIANNUALLY"] = "SEMIANNUALLY";
    PaymentCycle["YEARLY"] = "YEARLY";
    PaymentCycle["YEAR2"] = "YEAR2";
    PaymentCycle["YEAR3"] = "YEAR3";
    PaymentCycle["YEAR4"] = "YEAR4";
    PaymentCycle["YEAR5"] = "YEAR5";
    PaymentCycle["ONE_TIME"] = "ONE_TIME";
})(PaymentCycle = exports.PaymentCycle || (exports.PaymentCycle = {}));
var VoucherAllocationTypeBo;
(function (VoucherAllocationTypeBo) {
    VoucherAllocationTypeBo["WIX_DOMAIN"] = "WIX_DOMAIN";
    VoucherAllocationTypeBo["GOOGLE_ADDWORDS"] = "GOOGLE_ADDWORDS";
    VoucherAllocationTypeBo["GMAIL"] = "GMAIL";
    VoucherAllocationTypeBo["BING"] = "BING";
    VoucherAllocationTypeBo["YANDEX"] = "YANDEX";
    VoucherAllocationTypeBo["US_LOCAL_DIRECTORY"] = "US_LOCAL_DIRECTORY";
    VoucherAllocationTypeBo["CANADA_LOCAL_DIRECTORY"] = "CANADA_LOCAL_DIRECTORY";
    VoucherAllocationTypeBo["UBERALL"] = "UBERALL";
    VoucherAllocationTypeBo["LOGO"] = "LOGO";
})(VoucherAllocationTypeBo = exports.VoucherAllocationTypeBo || (exports.VoucherAllocationTypeBo = {}));
var VoucherAllocatorType;
(function (VoucherAllocatorType) {
    VoucherAllocatorType["voucherAllocatorForGoogle"] = "voucherAllocatorForGoogle";
    VoucherAllocatorType["voucherAllocatorUnlimited"] = "voucherAllocatorUnlimited";
    VoucherAllocatorType["usLocalDirectoryAllocator"] = "usLocalDirectoryAllocator";
    VoucherAllocatorType["caLocalDirectoryAllocator"] = "caLocalDirectoryAllocator";
    VoucherAllocatorType["voucherAllocatorForBing"] = "voucherAllocatorForBing";
    VoucherAllocatorType["voucherAllocatorUnlimited20years"] = "voucherAllocatorUnlimited20years";
    VoucherAllocatorType["tpaBundle123ContactFormAllocator"] = "tpaBundle123ContactFormAllocator";
    VoucherAllocatorType["tpaBundleSiteBoosterAllocator"] = "tpaBundleSiteBoosterAllocator";
    VoucherAllocatorType["voucherAllocatorForYandex"] = "voucherAllocatorForYandex";
    VoucherAllocatorType["wixMoneyAllocator"] = "wixMoneyAllocator";
    VoucherAllocatorType["gmailVoucherAllocator"] = "gmailVoucherAllocator";
    VoucherAllocatorType["tpaBundleWixFormAllocator"] = "tpaBundleWixFormAllocator";
    VoucherAllocatorType["userVoucherAllocator"] = "userVoucherAllocator";
    VoucherAllocatorType["tpaEventsCalenderAllocator"] = "tpaEventsCalenderAllocator";
    VoucherAllocatorType["tpaVisitorAnalyticsAllocator"] = "tpaVisitorAnalyticsAllocator";
    VoucherAllocatorType["voucherAllocatorForUberall"] = "voucherAllocatorForUberall";
    VoucherAllocatorType["voucherAllocatorForTinyErp"] = "voucherAllocatorForTinyErp";
    VoucherAllocatorType["tpaEasyTeamAllocator"] = "tpaEasyTeamAllocator";
})(VoucherAllocatorType = exports.VoucherAllocatorType || (exports.VoucherAllocatorType = {}));
var VoucherStatus;
(function (VoucherStatus) {
    VoucherStatus["UNKNOWN_VOUCHER_STATUS"] = "UNKNOWN_VOUCHER_STATUS";
    VoucherStatus["PENDING_AVAILABILITY"] = "PENDING_AVAILABILITY";
    VoucherStatus["AVAILABLE_TO_CLAIM"] = "AVAILABLE_TO_CLAIM";
    VoucherStatus["CLAIMED"] = "CLAIMED";
    VoucherStatus["USED"] = "USED";
    VoucherStatus["EXPIRED"] = "EXPIRED";
})(VoucherStatus = exports.VoucherStatus || (exports.VoucherStatus = {}));
var VoucherType;
(function (VoucherType) {
    VoucherType["UNKNOWN_VOUCHER_TYPE"] = "UNKNOWN_VOUCHER_TYPE";
    VoucherType["LOGO"] = "LOGO";
    VoucherType["LOGO_COUPON"] = "LOGO_COUPON";
    VoucherType["DOMAIN_COUPON"] = "DOMAIN_COUPON";
    VoucherType["GOOGLE_ADS_ADVERTISING"] = "GOOGLE_ADS_ADVERTISING";
    VoucherType["BING_ADVERTISING"] = "BING_ADVERTISING";
    VoucherType["YANDEX_ADVERTISING"] = "YANDEX_ADVERTISING";
    VoucherType["LOCAL_LISTING"] = "LOCAL_LISTING";
    VoucherType["TPA_COUPON"] = "TPA_COUPON";
    VoucherType["UBERALL"] = "UBERALL";
    VoucherType["GMAIL"] = "GMAIL";
    VoucherType["VIP_UNLIMITED_20_YEARS"] = "VIP_UNLIMITED_20_YEARS";
    VoucherType["USER_VOUCHER"] = "USER_VOUCHER";
    VoucherType["TINY_ERP"] = "TINY_ERP";
})(VoucherType = exports.VoucherType || (exports.VoucherType = {}));
var VouchersType;
(function (VouchersType) {
    VouchersType["GMAIL"] = "GMAIL";
    VouchersType["GOOGLE_ADS"] = "GOOGLE_ADS";
    VouchersType["VIP"] = "VIP";
    VouchersType["BING"] = "BING";
    VouchersType["LOCAL_LISTINGS"] = "LOCAL_LISTINGS";
})(VouchersType = exports.VouchersType || (exports.VouchersType = {}));
//# sourceMappingURL=types.js.map